<template>
  <campsite-subsection class="campsite-offers" name="offers" :open="$isDesktop">
    <template #title>
      <translate>Offers</translate>
    </template>
    <template #contents>
      <campsite-offers :pitchtypes="pitchtypes" />
      <p class="help-text">
        <i18n-t keypath="Conditions apply - {pitchTypeSectionLink}">
          <template #pitchTypeSectionLink>
            <translate
              v-scrollto="{
                target: '[data-pitchtypes-scroll-target]',
                options: { duration: 250 },
              }"
              class="jump-link"
            >
              see pitch type section for details
            </translate>
          </template>
        </i18n-t>
      </p>
    </template>
  </campsite-subsection>
</template>

<script lang="ts">
import { PitchType } from '../../../campsite-details/types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class CampsiteOffersSubsection extends Vue {
  @Prop({ required: true })
  pitchtypes: PitchType[]
}

export default toNative(CampsiteOffersSubsection)
</script>
<style scoped>
p {
  color: var(--colour-text-light);
  font-size: var(--body);
}

.jump-link {
  color: var(--colour-text-light);
  text-decoration: underline;
  cursor: pointer;
}

.campsite-offers.campsite-subsection {
  padding: 1em 1em 0 1em;
}

.campsite-offers :deep(footer) {
  margin: auto -1em;
}
</style>
